import styled from 'styled-components';

export const EmptyStateWrapper = styled.div`
  max-width: 600px;
`;
